/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import BackofficeMenu from 'components/BackofficeMenu';
import moment from 'moment';
import api from 'api';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import { Header } from 'components';
import { useHistory } from 'react-router-dom';
import {
  Container,
  ContentArea,
  Title,
  PolicyInformationArea,
  ItemPolicy,
  Subtitle,
  Text,
  LoadingArea,
  InspectionImage,
  PhotosArea,
  Card,
  ModalButton,
  Edit,
  inputStyle,
  DialogContent,
  FlexRow,
  FlexColumn,
  Label,
  InputPlate,
  PlateContainer,
  PlateHeader,
  PlateBody,
  ValueComparison,
  ValueCard,
  ErrorText,
  EndorsementSection,
  EndorsementCard,
  EndorsementHeader,
  EndorsementGrid,
  EndorsementInfo,
  EndorsementDivider,
  ProductItem,
  ProductItemButton,
  CoveragesArea,
} from './styles';
import {
  BsShieldFillCheck,
  BsBoxArrowUpRight,
  BsShieldFillX,
  BsShieldFillExclamation,
  BsFillCheckCircleFill,
  BsCircle,
} from 'react-icons/bs';
import {
  IoDocumentTextOutline,
  IoArrowForward,
  IoCarOutline,
  IoMapOutline,
  IoShieldCheckmarkOutline,
  IoPersonOutline,
  IoTimeOutline,
} from 'react-icons/io5';
import { formatCPF, formatCNPJ, formatPlate, formatCurrency, formatPhone } from 'react-data-formatter';
import { loadingColor, secondary, middleGray, white, darkGray } from 'styles/colorProvider';
import { formatPolicyStatus } from 'utils/policyStatus';
import { ConfirmDialog, Button, Input, Dialog, DueDayProrataPicker } from 'components';
import { getApiErrorMessage, isPreviewOk, isFixedDueDay, padDueDay } from 'components/DueDayProrataPicker';
import { getCardFlag } from 'utils/creditCard';
import { IOF, PartnerProduct } from 'utils/general';
import { maskZipCode } from 'utils/masks';
import { cpf } from 'cpf-cnpj-validator';
import { Alert } from '@material-ui/lab';
import { addMonthsByModality, translatePolicyModality } from 'utils/policyModality';
import { fetchAddressByCep } from '../../../utils/address';
import {
  formatPolicyReactivationStatus,
  getReactivationCurrentStatus,
  reactivationStatusEquals,
} from 'screens/BackofficeArea/ReactivationList/helper';

const translateInspectionStatus = {
  approved: 'Aprovado',
  rejected: 'Rejeitada',
  pending: 'Pendente',
  pending_approval: 'Aguardando avaliação de fotos',
};

function PolicyDetails({ location }) {
  const history = useHistory();
  const policyId = parseInt(location.pathname.split('/backoffice/detalhes-do-contrato/')[1]);

  const [policyData, setPolicyData] = useState({});
  const [reactivationStatus, setReactivationStatus] = useState(null);

  const [reportUrl, setReportUrl] = useState(null);
  const [loadingGetReport, setLoadingGetReport] = useState(false);

  const [confirmClaimPolicy, setConfirmClaimPolicy] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingCep, setLoadingCep] = useState(false);
  const [endorsements, setEndorsements] = useState({ plate: null, address: null, coverage: null, user: null });
  const [hasProducts, setHasProducts] = useState(false);
  const [clientActiveCard, setClientActiveCard] = useState();
  const [valueCoverage, setValueCoverage] = useState(0);
  const [valueService, setValueService] = useState(0);
  const [hasServices, setHasServices] = useState(false);
  const [hasCoverages, setHasCoverages] = useState(false);
  const [openUser, setOpenUser] = useState(false);
  const [userData, setUserData] = useState();
  const [policyInfo, setPolicyInfo] = useState({
    adjustmentFactor: '70%',
    adjustmentFactorValue: 70,
    userBetween18and25Years: false,
    franchiseValue: 'Normal-Obrigatória 10%',
  });

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isPlateDialogOpen, setIsPlateDialogOpen] = useState(false);
  const [newPlate, setNewPlate] = useState('');
  const [loadingPlate, setLoadingPlate] = useState(false);
  const [isAddressDialogOpen, setIsAddressDialogOpen] = useState(false);
  const [addressError, setAddressError] = useState(false);
  const [hasChange, setHasChange] = useState(false);
  const [isConfirmAddressDialogOpen, setIsConfirmAddressDialogOpen] = useState(false);
  const [confirmAddressData, setConfirmAddressData] = useState(null);
  const debounceRef = useRef(null);

  const [openDueDayPanel, setOpenDueDayPanel] = useState(false);
  const [policyDueDay, setPolicyDueDay] = useState(null);
  const [policyDueDayPreview, setPolicyDueDayPreview] = useState(null);
  const [dueDayRequesterName, setDueDayRequesterName] = useState('');
  const [loadingDueDay, setLoadingDueDay] = useState(false);

  const loadClientActiveCard = async () => {
    try {
      const response = await api({
        method: 'GET',
        url: `/policy-active-card/${policyId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        json: true,
      });
      setClientActiveCard(response.data);
    } catch (error) {}
  };

  const [quotationData, setQuotationData] = useState(null);

  const loadData = async () => {
    setLoading(true);
    const response = await api({
      method: 'GET',
      url: `/splitrisk-policy/${policyId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitrisk-authtoken'),
      },
      json: true,
    });
    let valueService = 0;
    let valueCoverage = 0;
    let hasCoverages = false;
    let hasServices = false;

    for (const item of response.data?.arrayUnique || []) {
      if (item.isService) {
        hasServices = true;
        valueService += Number(item.value);
      } else {
        hasCoverages = true;
        valueCoverage += Number(item.value);
      }
    }
    if (response.data?.products) {
      for (const item of response.data?.products || []) {
        if (item.isService) {
          hasServices = true;
          valueService += Number(item.value);
        } else {
          hasCoverages = true;
          valueCoverage += Number(item.value);
        }
      }
    }
    if (response.data?.coverages) {
      for (const item of response.data?.coverages || []) {
        if (item.isService) {
          hasServices = true;
          valueService += Number(item.value);
        } else {
          hasCoverages = true;
          valueCoverage += Number(item.value);
        }
      }
    }

    if (response.data?.coverages?.length) {
      hasCoverages = true;
      setValueCoverage(response?.data?.value_final);

      if (response?.data?.TB_PROPOSAL) {
        response.data.TB_PROPOSAL.iof = response?.data?.TB_PROPOSAL?.value_final * IOF;
      }
    } else {
      setValueCoverage(valueCoverage);
    }

    let currentReactivationStatus = null;
    if (response?.data?.status === 'canceled') {
      try {
        const resp = await api({
          method: 'GET',
          url: `/contracts/${policyId}/reactivation/current`,
          headers: {
            Accept: 'application/json',
            Authorization: Cookies.get('splitrisk-authtoken'),
          },
        });

        const payload = resp?.data;
        const reactivation = Object.prototype.hasOwnProperty.call(payload || {}, 'reactivation') ? payload.reactivation : payload;

        const rawStatus = getReactivationCurrentStatus(reactivation);
        const hasActiveReactivationFlow =
          rawStatus &&
          !reactivationStatusEquals(rawStatus, 'canceled') &&
          !reactivationStatusEquals(rawStatus, 'rejected_reactivation');

        if (hasActiveReactivationFlow) currentReactivationStatus = rawStatus;
      } catch (error) {
        console.error('Error fetching current reactivation status:', error);
      }
    }

    setPolicyData(response.data);
    setReactivationStatus(currentReactivationStatus);

    const clientHistory = (response.data?.TB_CLIENT_HISTORY || []).map((h) => {
      try {
        return { ...h, update_data: typeof h.update_data === 'string' ? JSON.parse(h.update_data) : h.update_data };
      } catch (e) {
        return h;
      }
    });

    const latestPlate = clientHistory.find((h) => h.action === 'plate_updated');
    const latestCoverage = clientHistory.find((h) => h.action === 'coverage_updated');
    const latestAddress = clientHistory.find((h) => {
      if (h.action !== 'registration_updated') return false;
      try {
        const data = typeof h.update_data === 'string' ? JSON.parse(h.update_data) : h.update_data;
        return !!data?.old_address;
      } catch {
        return false;
      }
    });

    const latestUser = clientHistory.find((h) => {
      if (h.action !== 'registration_updated') return false;
      try {
        const data = typeof h.update_data === 'string' ? JSON.parse(h.update_data) : h.update_data;
        return !!data?.old_data;
      } catch {
        return false;
      }
    });

    setEndorsements({
      plate: latestPlate,
      address: latestAddress,
      coverage: latestCoverage,
      user: latestUser,
    });

    setUserData(response.data.user);

    setHasCoverages(hasCoverages);
    setHasServices(hasServices);
    setLoading(false);
    setValueService(valueService);

    const policy = response.data;

    const initialQuotation = {
      vehicle: {
        id_brand: policy?.vehicle?.id_brand,
        fipe_code: policy?.vehicle?.fipe_code,
        value: policy?.vehicle?.value,
        id_type: policy?.vehicle?.id_vehicle_type,
        zero_km: policy?.vehicle?.zero_km,
      },
      quotationProposalData: {
        quotationProposalId: policy?.TB_PROPOSAL?.id,
      },
      policy_modality: policy?.modality,
      products: policy?.TB_PROPOSAL?.TB_QUOTATION_PROPOSAL?.[0] || null,
    };
    setQuotationData(initialQuotation);
  };

  const handleCreateClaimPolicy = async () => {
    setLoading(true);
    try {
      const resp = await api({
        method: 'post',
        url: `/claim-policy-mark`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        data: {
          id: policyId,
        },
      });
      setConfirmClaimPolicy(resp);
      setLoading(false);
      toast.success('Contrato com sinistro!', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      setConfirmClaimPolicy(false);
      loadData();
    } catch (error) {
      toast.error(error?.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      setLoading(false);
      setConfirmClaimPolicy(false);
    }
  };

  const handleUpdateProposal = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phone = (userData?.phone || '').replace(/\D/g, '');

    if (!emailRegex.test(userData.email)) {
      return toast.error('Informe um e-mail válido.', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    }

    if (phone.length < 10 || phone.length > 11) {
      return toast.error('Informe um telefone válido.', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    }

    setLoading(true);

    try {
      await api({
        method: 'PATCH',
        url: `/backoffice-update-user/${userData.id}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        data: {
          ...userData,
          id_policy: policyData?.id,
          social_name: userData?.social_name?.toUpperCase(),
        },
        json: true,
      });

      setLoading(false);
      setOpenUser(false);

      toast.success('Usuário atualizado com sucesso!', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });

      loadData();
    } catch (error) {
      setLoading(false);

      toast.error(error?.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    }
  };

  const handleOpenEditUser = () => {
    setOpenUser(true);
  };

  const handleGetReport = async (protocol) => {
    if (reportUrl) {
      window.open(reportUrl, '_blank');
      return;
    }
    setLoadingGetReport(true);
    try {
      const response = await api({
        method: 'GET',
        url: `/inspections/${protocol}/report`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
      });
      setLoadingGetReport(false);
      setReportUrl(response?.data.reportUrl);
      window.open(response?.data.reportUrl, '_blank');
    } catch (e) {
      toast.error('Essa vistoria não possui relatório na InfoVist', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      setLoadingGetReport(false);
    }
  };

  const renderConfirmClaimPolicy = () => (
    <ConfirmDialog
      open={confirmClaimPolicy}
      onCancel={() => setConfirmClaimPolicy(false)}
      content="Ao confirmar o contrato não será renovada automáticamente"
      title="Contrato com Sinistro"
      onConfirm={handleCreateClaimPolicy}
      loading={loading}
    />
  );

  const checkProducts = async () => {
    try {
      const response = await api({
        method: 'GET',
        url: `/proposal-has-products/${policyData?.id_proposal}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        json: true,
      });

      setHasProducts(response?.data?.hasProducts);
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Erro carregando os produtos!', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    }
  };

  useEffect(() => {
    loadClientActiveCard();
    loadData();
  }, []);

  useEffect(() => {
    if (!policyData?.id_proposal) return;
    checkProducts();
  }, [policyData]);

  const iof = 0.078;

  useEffect(() => {
    // LMI LOGIC
    const auctionOrRemarked = policyData?.vehicle?.auction || policyData?.vehicle?.remarked;
    // Starts with 70% <- Auction or Remarked
    let adjustmentFactor = '70%';
    let adjustmentFactorValue = 70;

    if (!auctionOrRemarked) {
      const adjustmentsFactors =
        policyData?.TB_PROPOSAL?.TB_QUOTATION_PROPOSAL?.[0]?.TB_PRICING_FIPE_LMI_TB_QUOTATION_PROPOSAL?.filter(
          (item) => item?.active,
        );

      // If has valid LMI or 100%
      adjustmentFactor = adjustmentsFactors?.[0]?.TB_PRICING_FIPE_LMI?.name || '100%';
      adjustmentFactorValue = adjustmentsFactors?.[0]?.TB_PRICING_FIPE_LMI?.lmi || 100;
    }

    // Franchise Logic
    const showFranchiseValue =
      policyData?.TB_PROPOSAL?.TB_QUOTATION_PROPOSAL?.[0]?.TB_PRICING_DEDUCTIBLE_TB_QUOTATION_PROPOSAL?.[0]?.TB_PRICING_DEDUCTIBLE
        ?.enabled;

    const franchiseValue =
      policyData?.TB_PROPOSAL?.TB_QUOTATION_PROPOSAL?.[0]?.TB_PRICING_DEDUCTIBLE_TB_QUOTATION_PROPOSAL?.filter(
        (c) => c?.active,
      )?.[0]?.TB_PRICING_DEDUCTIBLE?.name;
    const oldFranchiseValue = policyData.coverages?.find((c) => c?.name?.includes('Franquia'))?.name_complete;

    // User Between 18 and 25 years
    const userBetween18and25Years = policyData?.TB_PROPOSAL?.TB_QUOTATION_PROPOSAL?.[0]?.some_driver_18_25_years_old;

    const isMotorcycle = policyData?.vehicle?.id_vehicle_type === 4;

    const defaultFranchiseValue = isMotorcycle ? 'Normal-Obrigatória 20%' : 'Normal-Obrigatória 10%';

    setPolicyInfo({
      ...policyInfo,
      adjustmentFactor,
      adjustmentFactorValue,
      userBetween18and25Years,
      franchiseValue:
        showFranchiseValue && franchiseValue ? franchiseValue : oldFranchiseValue ? oldFranchiseValue : defaultFranchiseValue,
    });
  }, [policyData]);

  const isCpf = cpf.isValid(policyData?.user?.cpf);

  const handlePolicyValidityStartDate = () => {
    if (policyData?.user?.TB_PARTNERS?.product === PartnerProduct.enterprise) {
      return moment.utc(policyData?.expiration_date).startOf('month').format('DD/MM/YYYY');
    }

    return policyData?.modality === 'monthly'
      ? moment
          .utc(policyData?.expiration_date)
          .subtract(1, 'months')
          .set('date', moment.utc(policyData?.expiration_date).date())
          .format('DD/MM/YYYY')
      : moment.utc(policyData?.created_at).format('DD/MM/YYYY');
  };

  const handleUpdatePlate = async () => {
    if (newPlate.length < 7) {
      toast.error('Insira uma placa válida.');
      return;
    }

    setLoadingPlate(true);

    try {
      const payload = {
        id_vehicle: policyData?.TB_PROPOSAL?.id_vehicle || policyData?.id_vehicle,
        id_proposal: policyData?.TB_PROPOSAL?.id || policyId,
        plate: newPlate,
      };

      const response = await api({
        method: 'POST',
        url: '/mercosul',
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        data: payload,
      });

      toast.success('Placa alterada com sucesso!', response.data);
      setIsPlateDialogOpen(false);
      setNewPlate('');
      loadData();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const mensagemDoServidor = error.response.data.error;
        toast.error(mensagemDoServidor);
      } else {
        toast.error('Ocorreu um erro inesperado ao validar a placa.');
      }
    } finally {
      setLoadingPlate(false);
    }
  };

  const [address, setAddress] = useState({
    zip_code: '',
    street: '',
    number: '',
    complement: '',
    district: '',
    city: '',
    state: '',
  });

  const handleChangeCep = (e) => {
    const value = e.target.value;

    setAddress((prev) => ({
      ...prev,
      zip_code: value,
    }));

    const cleanCep = value.replace(/\D/g, '');
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    if (cleanCep.length !== 8) {
      setAddressError(false);

      setAddress((prev) => ({
        ...prev,
        street: '',
        district: '',
        city: '',
        state: '',
      }));
      return;
    }

    debounceRef.current = setTimeout(async () => {
      try {
        setLoadingCep(true);
        const response = await fetchAddressByCep(cleanCep);

        if (!response || response.error) {
          setAddressError(true);
          return;
        }

        setAddress((prev) => ({
          ...prev,
          zip_code: response.zip_code,
          street: response.street,
          district: response.district,
          city: response.city,
          state: response.state,
        }));
      } catch (error) {
        setAddressError(true);
      } finally {
        setLoadingCep(false);
      }
    }, 500);
  };

  const handleAlterAddress = async (confirm = false) => {
    try {
      setLoading(true);

      const payload = {
        id: policyData?.TB_PROPOSAL?.TB_QUOTATION_PROPOSAL?.[0]?.id,
        new_cep: address.zip_code,
        street: address.street,
        number: address.number,
        complement: address.complement,
        district: address.district,
        city: address.city,
        state: address.state,
        confirm: confirm,
      };

      const response = await api({
        method: 'POST',
        url: '/alter-address',
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        data: payload,
      });

      const data = response.data;

      if (data.needsConfirmation && !confirm) {
        setConfirmAddressData(data.data);
        setIsConfirmAddressDialogOpen(true);
        setLoading(false);
        return;
      }

      setIsAddressDialogOpen(false);
      setIsConfirmAddressDialogOpen(false);

      if (data.updated && data.data && data.data.difference !== 0) {
        try {
          await api({
            method: 'POST',
            url: `/refactor-quotation-value-proposal/${policyData.id_proposal}`,
            headers: {
              'Content-Type': 'application/json',
              Authorization: Cookies.get('splitrisk-authtoken'),
            },
            data: {
              value: data.data.estimatedNewTotal,
              origin: 'address_change',
            },
          });
        } catch (refactorError) {
          toast.error('Erro ao processar novo valor do contrato. Verifique o histórico.');
        }
      }

      toast.success('Endereço alterado com sucesso!');
      setIsAddressDialogOpen(false);
      setIsConfirmAddressDialogOpen(false);
      loadData();
    } catch (error) {
      const errorMsg = error?.response?.data?.error || 'Erro ao alterar endereço';
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDueDayPanel = () => {
    setOpenDueDayPanel(false);
    setPolicyDueDay(null);
    setPolicyDueDayPreview(null);
    setDueDayRequesterName('');
    setLoadingDueDay(false);
  };

  const handleOpenDueDayPanel = () => {
    setPolicyDueDay(null);
    setPolicyDueDayPreview(null);
    setDueDayRequesterName('');
    setOpenDueDayPanel(true);
  };

  const getDueDayApplyErrorMessage = (err) => {
    const status = err?.response?.status;
    let fallback = 'Não foi possível alterar o dia de vencimento';
    if (status === 400) fallback = 'A alteração de vencimento não pôde ser aplicada a este contrato.';
    if (status === 409) fallback = 'Já existe uma alteração de vencimento pendente de pagamento para este contrato.';
    if (status === 502) fallback = 'Falha ao atualizar a cobrança no gateway de pagamento. Tente novamente em instantes.';
    return getApiErrorMessage(err, fallback);
  };

  const handleApplyDueDay = async () => {
    if (!policyId) return;
    const requesterName = dueDayRequesterName.trim();
    if (!isFixedDueDay(policyDueDay) || !isPreviewOk(policyDueDayPreview)) {
      toast.error('Selecione o dia de vencimento antes de prosseguir.', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      return;
    }
    if (!requesterName || requesterName.length > 50) {
      toast.error('Informe o nome do solicitante (até 50 caracteres).', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      return;
    }

    setLoadingDueDay(true);
    try {
      await api({
        method: 'POST',
        url: `/contracts/${policyId}/due-day/apply`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        data: { dueDay: policyDueDay, requesterName },
      });
      toast.success('Data de vencimento alterada com sucesso!', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      handleCloseDueDayPanel();
      loadData();
    } catch (err) {
      toast.error(getDueDayApplyErrorMessage(err), {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingDueDay(false);
    }
  };

  const renderDueDayDialog = () => (
    <Dialog open={openDueDayPanel} onClose={handleCloseDueDayPanel} width="520px" title="Alterar data de vencimento">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <p style={{ margin: 0, fontSize: 13, color: middleGray, lineHeight: 1.5 }}>
          Dia de vencimento atual do contrato:{' '}
          <strong style={{ color: darkGray }}>{policyData?.due_day != null ? padDueDay(policyData.due_day) : '-'}</strong>
        </p>
        <DueDayProrataPicker
          previewUrl={`/contracts/${policyId}/due-day/preview`}
          allowCurrentDate={false}
          dueDay={policyDueDay}
          onDueDayChange={setPolicyDueDay}
          onPreviewChange={setPolicyDueDayPreview}
          disabled={loadingDueDay}
        />
        <Input
          label="Nome do solicitante"
          placeholder="Obrigatório (máx. 50 caracteres)"
          value={dueDayRequesterName}
          onChange={(e) => setDueDayRequesterName(e.target.value.slice(0, 50))}
          height="36px"
          width="100%"
          disabled={loadingDueDay}
        />
        <ModalButton style={{ justifyContent: 'center', display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          <Button
            height="38px"
            onClick={handleApplyDueDay}
            disabled={
              loadingDueDay ||
              !isFixedDueDay(policyDueDay) ||
              !isPreviewOk(policyDueDayPreview) ||
              !dueDayRequesterName.trim()
            }
            style={{ minWidth: 180 }}
          >
            {loadingDueDay ? <ReactLoading color={white} height={20} width={20} type="spin" /> : 'Prosseguir'}
          </Button>
          <Button height="34px" outlined onClick={handleCloseDueDayPanel} disabled={loadingDueDay}>
            Cancelar
          </Button>
        </ModalButton>
      </div>
    </Dialog>
  );

  return (
    <>
      {renderConfirmClaimPolicy()}
      {renderDueDayDialog()}
      <Header />
      <Container>
        {loading && (
          <LoadingArea>
            <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
          </LoadingArea>
        )}

        {!loading && (
          <ContentArea>
            <BackofficeMenu
              policyId={policyId}
              policyData={policyData}
              hasProducts={hasProducts}
              hasProviderSupport={!!policyData?.user?.TB_PARTNERS?.id_provider_support}
            />
            <Title>DETALHES DO CONTRATO</Title>
            {policyData?.status === 'active' && policyData?.not_renew === true && (
              <Alert style={{ marginBottom: 20 }} severity="warning">
                Cancelamento solicitado - Sua vigência é válida até o próximo vencimento{' '}
                {moment(policyData.next_due).format('DD/MM/YYYY')}
              </Alert>
            )}

            <PolicyInformationArea>
              {/* DADOS CONTRATO */}
              <ItemPolicy>
                <Subtitle>Dados da contrato - {policyData?.subscription}</Subtitle>
                {policyData?.claim_notice === true ? (
                  <>
                    <Text>
                      Contrato com sinistro: <span>Sim</span>
                    </Text>
                  </>
                ) : (
                  <>
                    <Text>
                      Contrato com sinistro: <span>Não</span>
                    </Text>
                  </>
                )}

                <Text>
                  Status:{' '}
                  <span>
                    {reactivationStatus
                      ? formatPolicyReactivationStatus(reactivationStatus)?.label || reactivationStatus
                      : formatPolicyStatus(policyData?.status)?.label}
                  </span>
                </Text>

                <Text>
                  Protocolo: <span>{policyData?.policy_number}</span>
                </Text>
                <Text>
                  Contrato: <span>{policyData?.code_ebao}</span>
                </Text>
                {hasCoverages && (
                  <Text>
                    Valor Coberturas:{' '}
                    <span>{`${formatCurrency(
                      (policyData?.isHinova ? policyData?.valueFinal : valueCoverage) - policyData?.TB_PROPOSAL?.iof,
                    )}`}</span>
                  </Text>
                )}
                {hasCoverages && (
                  <Text>
                    Valor IOF sobre Coberturas: <span>{`${formatCurrency(policyData?.TB_PROPOSAL?.iof || 0)}`}</span>
                  </Text>
                )}
                {hasServices && (
                  <Text>
                    Valor Serviços: <span>{`${formatCurrency(valueService)}`}</span>
                  </Text>
                )}
                <Text>
                  Valor Total do Seguros: <span>{`${formatCurrency(policyData?.valueFinal || 0)}`}</span>
                </Text>
                <Text>
                  Data final de vigência: <span>{moment(policyData?.expiration_date).format('DD/MM/YYYY')}</span>
                </Text>
                <Text>
                  Fator de ajuste LMI: <span>{policyInfo?.adjustmentFactor}</span>
                </Text>
                <Text>
                  Franquia: <span>{policyInfo?.franchiseValue}</span>
                </Text>
                <Text>
                  Estado de Circulação: <span>{policyData?.TB_ADDRESS?.state}</span>
                </Text>
                <Text>
                  Agente de vendas: <span>{policyData?.TB_PROPOSAL?.TB_USERS_TB_PROPOSAL_id_authorToTB_USERS?.name || '-'}</span>
                </Text>
                <Text>
                  E-mail do agente: <span>{policyData?.TB_PROPOSAL?.TB_USERS_TB_PROPOSAL_id_authorToTB_USERS?.email || '-'}</span>
                </Text>
                <Text>
                  Telefone do agente:{' '}
                  <span>{formatPhone(policyData?.TB_PROPOSAL?.TB_USERS_TB_PROPOSAL_id_authorToTB_USERS?.phone) || '-'}</span>
                </Text>

                {policyData?.status !== 'canceled' && policyData?.claim_notice !== true && (
                  <>
                    <Button className="buttonCancelProposal" onClick={() => setConfirmClaimPolicy(true)}>
                      Contrato com sinistro
                    </Button>
                  </>
                )}
              </ItemPolicy>

              {/* ENDOSO */}
              <ItemPolicy>
                <EndorsementSection>
                  <Subtitle>Informações do Endosso</Subtitle>
                  {/* placa */}
                  <EndorsementCard>
                    {' '}
                    <EndorsementHeader>
                      {' '}
                      <IoCarOutline /> <h3>Alteração de Placa</h3>{' '}
                    </EndorsementHeader>{' '}
                    <EndorsementGrid>
                      {' '}
                      <EndorsementInfo>
                        {' '}
                        <label>De → Para</label>{' '}
                        <span className="value-row">
                          {' '}
                          <span className="old">{endorsements.plate?.update_data?.old_plate || '--'}</span>{' '}
                          <IoArrowForward size={14} color={middleGray} />{' '}
                          <span className="new">{endorsements.plate?.update_data?.new_plate || '--'}</span>{' '}
                        </span>{' '}
                      </EndorsementInfo>{' '}
                      <EndorsementInfo>
                        {' '}
                        <label>Responsável</label>{' '}
                        <span>{endorsements.plate?.TB_USERS_TB_CLIENT_HISTORY_id_authorToTB_USERS?.name || '--'}</span>{' '}
                      </EndorsementInfo>{' '}
                      <EndorsementInfo>
                        {' '}
                        <label>Data</label>{' '}
                        <span>
                          {' '}
                          {endorsements.plate ? moment(endorsements.plate.created_at).format('DD/MM/YYYY HH:mm') : '--'}{' '}
                        </span>{' '}
                      </EndorsementInfo>{' '}
                    </EndorsementGrid>{' '}
                  </EndorsementCard>
                  {/* ---FORMULÁRIO DA PLACA --- */}
                  <Dialog
                    open={isPlateDialogOpen}
                    onClose={() => setIsPlateDialogOpen(false)}
                    width="400px"
                    title="Trocar Placa Mercosul"
                  >
                    {' '}
                    <DialogContent alignItems="center" gap="20px">
                      {' '}
                      <Text style={{ textAlign: 'center', fontSize: '14px', marginBottom: '10px' }}>
                        {' '}
                        Informe a nova placa do veículo:{' '}
                      </Text>{' '}
                      <PlateContainer>
                        {' '}
                        <PlateHeader>
                          {' '}
                          <span>Brasil</span>{' '}
                        </PlateHeader>{' '}
                        <PlateBody>
                          {' '}
                          <InputPlate
                            type="text"
                            value={newPlate}
                            onChange={(e) => setNewPlate(e.target.value.toUpperCase())}
                            placeholder="ABC1D23"
                            maxLength={7}
                          />{' '}
                        </PlateBody>{' '}
                      </PlateContainer>{' '}
                      <FlexRow width="100%" justifyContent="center" gap="15px">
                        {' '}
                        <Button
                          height="40px"
                          width="140px"
                          onClick={handleUpdatePlate}
                          loading={loadingPlate}
                          disabled={loadingPlate || newPlate.length < 7}
                        >
                          {' '}
                          Confirmar{' '}
                        </Button>{' '}
                        <Button outlined height="40px" width="140px" onClick={() => setIsPlateDialogOpen(false)}>
                          {' '}
                          Voltar{' '}
                        </Button>{' '}
                      </FlexRow>{' '}
                    </DialogContent>{' '}
                  </Dialog>

                  {/* endereço */}
                  <EndorsementCard>
                    {' '}
                    <EndorsementHeader>
                      {' '}
                      <IoMapOutline /> <h3>Alteração de Endereço</h3>{' '}
                    </EndorsementHeader>{' '}
                    <EndorsementGrid>
                      {' '}
                      <EndorsementInfo>
                        {' '}
                        <label>CEP: De → Para</label>{' '}
                        <span className="value-row">
                          {' '}
                          <span className="old">
                            {' '}
                            {maskZipCode(endorsements.address?.update_data?.old_address?.zip_code || '') || '--'}{' '}
                          </span>{' '}
                          <IoArrowForward size={14} color={middleGray} />{' '}
                          <span className="new">
                            {' '}
                            {maskZipCode(endorsements.address?.update_data?.new_address?.zip_code || '') || '--'}{' '}
                          </span>{' '}
                        </span>{' '}
                      </EndorsementInfo>{' '}
                      <EndorsementInfo>
                        {' '}
                        <label>Responsável</label>{' '}
                        <span>{endorsements.address?.TB_USERS_TB_CLIENT_HISTORY_id_authorToTB_USERS?.name || '--'}</span>{' '}
                      </EndorsementInfo>{' '}
                      <EndorsementInfo>
                        {' '}
                        <label>Data</label>{' '}
                        <span>
                          {' '}
                          {endorsements.address ? moment(endorsements.address.created_at).format('DD/MM/YYYY HH:mm') : '--'}{' '}
                        </span>{' '}
                      </EndorsementInfo>{' '}
                    </EndorsementGrid>{' '}
                  </EndorsementCard>
                  {/* --- FORMULÁRIO DE ENDEREÇO --- */}
                  <Dialog
                    open={isAddressDialogOpen}
                    onClose={() => setIsAddressDialogOpen(false)}
                    width="650px"
                    title="Alterar Endereço"
                  >
                    {' '}
                    <DialogContent gap="5px">
                      {' '}
                      <Text style={{ marginBottom: '15px' }}>Preencha os novos dados de localização do segurado:</Text>{' '}
                      <FlexRow gap="15px">
                        {' '}
                        <FlexColumn width="30%">
                          {' '}
                          <Input
                            label="CEP"
                            width="100%"
                            height="40px"
                            placeholder="00000-000"
                            value={address?.zip_code}
                            onChange={handleChangeCep}
                          />{' '}
                          {loadingCep && <ReactLoading height={20} width={20} type="spin" color={secondary} />}{' '}
                          {addressError && <ErrorText>CEP não encontrado</ErrorText>}{' '}
                        </FlexColumn>{' '}
                        <FlexColumn width="70%">
                          {' '}
                          <Input
                            label="Logradouro"
                            width="100%"
                            height="40px"
                            placeholder="Rua, Avenida..."
                            value={address.street}
                            onChange={(e) => setAddress({ ...address, street: e.target.value })}
                          />{' '}
                        </FlexColumn>{' '}
                      </FlexRow>{' '}
                      <FlexRow gap="15px">
                        {' '}
                        <FlexColumn width="30%">
                          {' '}
                          <Input
                            label="Número"
                            width="100%"
                            height="40px"
                            placeholder="123"
                            value={address?.number}
                            onChange={(e) => {
                              setAddress({ ...address, number: e.target.value });
                              setHasChange(true);
                            }}
                          />{' '}
                        </FlexColumn>{' '}
                        <FlexColumn width="70%">
                          {' '}
                          <Input
                            label="Complemento"
                            width="100%"
                            height="40px"
                            placeholder="Apto, Bloco..."
                            value={address.complement}
                            onChange={(e) => {
                              setAddress({ ...address, complement: e.target.value });
                              setHasChange(true);
                            }}
                          />{' '}
                        </FlexColumn>{' '}
                      </FlexRow>{' '}
                      <FlexRow gap="15px">
                        {' '}
                        <FlexColumn width="40%">
                          {' '}
                          <Input
                            label="Bairro"
                            width="100%"
                            height="40px"
                            placeholder="Bairro"
                            value={address.district}
                            onChange={(e) => setAddress({ ...address, district: e.target.value })}
                          />{' '}
                        </FlexColumn>{' '}
                        <FlexColumn width="45%">
                          {' '}
                          <Input
                            label="Cidade"
                            width="100%"
                            height="40px"
                            placeholder="Cidade"
                            value={address.city}
                            onChange={(e) => setAddress({ ...address, city: e.target.value })}
                          />{' '}
                        </FlexColumn>{' '}
                        <FlexColumn width="15%">
                          {' '}
                          <Input
                            label="UF"
                            width="100%"
                            height="40px"
                            placeholder="UF"
                            value={address.state}
                            maxLength={2}
                            onChange={(e) => setAddress({ ...address, state: e.target.value.toUpperCase() })}
                          />{' '}
                        </FlexColumn>{' '}
                      </FlexRow>{' '}
                      <FlexRow width="100%" justifyContent="center" gap="15px" marginTop="25px">
                        {' '}
                        <Button
                          height="45px"
                          width="180px"
                          onClick={() => handleAlterAddress(false)}
                          disabled={!address?.zip_code || !address?.street || !address?.number || loading || addressError}
                        >
                          {loading ? <ReactLoading height={20} width={20} type="spin" color="#fff" /> : 'Solicitar Alteração'}
                        </Button>{' '}
                        <Button outlined height="45px" width="180px" onClick={() => setIsAddressDialogOpen(false)}>
                          {' '}
                          Cancelar{' '}
                        </Button>{' '}
                      </FlexRow>{' '}
                    </DialogContent>{' '}
                  </Dialog>
                  {/* DIÁLOGO DE CONFIRMAÇÃO DE VALOR - ENDEREÇO */}
                  <ConfirmDialog
                    open={isConfirmAddressDialogOpen}
                    onCancel={() => setIsConfirmAddressDialogOpen(false)}
                    title="Confirmação de Alteração de Valor"
                    centered
                    content={
                      confirmAddressData ? (
                        <DialogContent alignItems="center" padding="0">
                          {' '}
                          <Text style={{ textAlign: 'center', fontSize: '16px', marginBottom: '10px' }}>
                            {' '}
                            Alterar o endereço irá mudar o valor do contrato:{' '}
                          </Text>{' '}
                          <ValueComparison>
                            {' '}
                            <ValueCard>
                              {' '}
                              <label>Atual</label> <span>{formatCurrency(confirmAddressData.currentTotal)}</span>{' '}
                            </ValueCard>{' '}
                            <IoArrowForward size={24} color={middleGray} />{' '}
                            <ValueCard
                              active
                              variant={
                                confirmAddressData.difference > 0
                                  ? 'error'
                                  : confirmAddressData.difference < 0
                                    ? 'success'
                                    : 'primary'
                              }
                            >
                              {' '}
                              <label>Novo</label> <span>{formatCurrency(confirmAddressData.estimatedNewTotal)}</span>{' '}
                            </ValueCard>{' '}
                          </ValueComparison>{' '}
                          <Text style={{ textAlign: 'center', fontWeight: '500' }}>Deseja confirmar a alteração?</Text>{' '}
                        </DialogContent>
                      ) : (
                        ''
                      )
                    }
                    onConfirm={() => handleAlterAddress(true)}
                    loading={loading}
                  />

                  {/* cobertura */}
                  <EndorsementCard>
                    {' '}
                    <EndorsementHeader>
                      {' '}
                      <IoShieldCheckmarkOutline /> <h3>Alteração de Coberturas</h3>{' '}
                    </EndorsementHeader>{' '}
                    <EndorsementGrid>
                      {' '}
                      <EndorsementInfo>
                        {' '}
                        <label>Status</label> <span>{endorsements.coverage ? 'Atualizado' : 'Nenhuma alteração registrada'}</span>{' '}
                      </EndorsementInfo>{' '}
                      <EndorsementInfo>
                        {' '}
                        <label>Data</label>{' '}
                        <span>
                          {' '}
                          {endorsements.coverage
                            ? moment(endorsements.coverage.created_at).format('DD/MM/YYYY HH:mm')
                            : '--'}{' '}
                        </span>{' '}
                      </EndorsementInfo>{' '}
                    </EndorsementGrid>{' '}
                  </EndorsementCard>

                  <EndorsementDivider>
                    <span>Ações Disponíveis</span>
                  </EndorsementDivider>

                  {/* botoes */}
                  <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
                    {' '}
                    <DialogContent padding="20px" gap="10px">
                      {' '}
                      <Subtitle>Selecione o tipo de alteração</Subtitle>{' '}
                      <FlexRow gap="10px" marginTop="20px" flexWrap="wrap">
                        {' '}
                        {/* botão placa */}
                        <Button
                          height="40px"
                          style={{
                            flex: 1,
                            background: 'transparent',
                            border: '1.5px solid #0000cc',
                            color: '#333',
                            whiteSpace: 'nowrap',
                          }}
                          onClick={() => {
                            setIsDialogOpen(false);
                            setIsPlateDialogOpen(true);
                          }}
                        >
                          {' '}
                          Alteração de placa{' '}
                        </Button>{' '}
                        {/* botão endereço */}
                        <Button
                          height="40px"
                          style={{
                            flex: 1,
                            background: 'transparent',
                            border: '1.5px solid #0000cc',
                            color: '#333',
                            whiteSpace: 'nowrap',
                          }}
                          onClick={() => {
                            setAddress({
                              zip_code: policyData?.TB_ADDRESS?.zip_code || '',
                              street: policyData?.TB_ADDRESS?.street || '',
                              number: policyData?.TB_ADDRESS?.number || '',
                              complement: policyData?.TB_ADDRESS?.complement || '',
                              district: policyData?.TB_ADDRESS?.district || '',
                              city: policyData?.TB_ADDRESS?.city || '',
                              state: policyData?.TB_ADDRESS?.state || '',
                            });
                            setIsAddressDialogOpen(true);
                            setIsDialogOpen(false);
                          }}
                        >
                          {' '}
                          Alteração de endereço{' '}
                        </Button>{' '}
                        {/* botão coberturas */}
                        <Button
                          height="40px"
                          style={{
                            flex: 1,
                            background: 'transparent',
                            border: '1.5px solid #0000cc',
                            color: '#333',
                            whiteSpace: 'nowrap',
                          }}
                          onClick={() => {
                            setIsDialogOpen(false);
                            history.push(`/backoffice/endosso/${policyData.id}`);
                          }}
                        >
                          {' '}
                          Alteração de Coberturas{' '}
                        </Button>{' '}
                      </FlexRow>{' '}
                      <hr style={{ border: '0.5px solid #eee', margin: '20px 0' }} />{' '}
                      <Button className="buttonCancelProposal" height="40px" width="100%" onClick={() => setIsDialogOpen(false)}>
                        {' '}
                        Voltar{' '}
                      </Button>{' '}
                    </DialogContent>{' '}
                  </Dialog>

                  {policyData?.status === 'active' && (
                    <Button
                      className="buttonCancelProposal"
                      onClick={() => setIsDialogOpen(true)}
                      style={{ width: '100%', marginTop: '10px' }}
                    >
                      {' '}
                      Solicitar alteração no contrato{' '}
                    </Button>
                  )}
                </EndorsementSection>
              </ItemPolicy>

              {/* VIGENCIA */}
              <ItemPolicy>
                {<Subtitle>Contrato gerado em:</Subtitle>}
                <Text style={{ marginBottom: '1.3rem' }}>{moment.utc(policyData?.created_at).format('DD/MM/YYYY')}</Text>

                <Subtitle>Modalidade de contratação:</Subtitle>
                <Text style={{ marginBottom: '1.3rem' }}>{translatePolicyModality(policyData?.modality)}</Text>

                <Subtitle>Inicio da vigência contrato:</Subtitle>
                <Text style={{ marginBottom: '1.3rem' }}>{handlePolicyValidityStartDate()}</Text>

                <Subtitle>Fim da vigência contrato:</Subtitle>
                <Text style={{ marginBottom: '1.3rem' }}>
                  {policyData?.modality === 'monthly'
                    ? moment.utc(policyData?.expiration_date).format('DD/MM/YYYY')
                    : addMonthsByModality(policyData?.created_at, policyData?.modality).format('DD/MM/YYYY')}
                </Text>

                <Subtitle>Inicio da vigência cobertura:</Subtitle>
                <Text style={{ marginBottom: '1.3rem' }}>
                  {policyData?.user?.TB_PARTNERS?.product === PartnerProduct.enterprise
                    ? moment.utc(policyData?.expiration_date).startOf('month').format('DD/MM/YYYY')
                    : moment
                        .utc(policyData?.expiration_date)
                        .subtract(1, 'months')
                        .set('date', moment.utc(policyData?.expiration_date).date())
                        .format('DD/MM/YYYY')}
                </Text>

                <Subtitle>Fim da vigência cobertura:</Subtitle>
                <Text style={{ marginBottom: '1.3rem' }}>{moment.utc(policyData?.expiration_date).format('DD/MM/YYYY')}</Text>

                {policyData?.status !== 'active' ? <Subtitle>Vencido em</Subtitle> : <Subtitle>Próximo vencimento:</Subtitle>}
                <Text style={{ marginBottom: policyData?.status === 'active' ? '0.4rem' : '1.3rem' }}>
                  {moment.utc(policyData?.next_due).format('DD/MM/YYYY')}
                  {policyData?.due_day != null ? ` (dia ${policyData.due_day})` : ''}
                </Text>
                {policyData?.status === 'active' ? (
                  <div style={{ marginBottom: '1.3rem' }}>
                    <Button height="32px" outlined onClick={handleOpenDueDayPanel}>
                      Alterar data de vencimento
                    </Button>
                  </div>
                ) : null}

                <Subtitle>Cobrança automática:</Subtitle>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
                  <Text style={{ margin: '0 1px 0 0' }}>{policyData?.automatic_charge ? 'Ativa' : 'Inativa'}</Text>
                </div>

                {policyData?.automatic_charge && clientActiveCard && (
                  <Card>
                    <Text>
                      Cartão:
                      <span> **** **** **** {clientActiveCard?.last_four_digits}</span>
                    </Text>
                    <div>{getCardFlag(clientActiveCard?.last_four_digits, clientActiveCard?.brand).image}</div>
                  </Card>
                )}
              </ItemPolicy>

              {/* SEGURADO */}
              <ItemPolicy>
                <Edit>
                  <Subtitle>Informações do usuário</Subtitle>
                </Edit>
                <Text>
                  Nome do usuário: <span>{policyData?.user?.name}</span>
                </Text>
                <Text>
                  Nome social: <span>{policyData?.user?.social_name}</span>
                </Text>
                <Text>
                  CPF: <span>{formatCPF(policyData?.user?.cpf)}</span>
                </Text>
                {isCpf && (
                  <Text>
                    Data de nascimento: <span>{moment.utc(policyData?.user?.birthdate).format('DD/MM/YYYY')}</span>
                  </Text>
                )}
                <Text>
                  Telefone: <span>{formatPhone(policyData?.user?.phone)}</span>
                </Text>
                <Text>
                  E-mail: <span>{policyData?.user?.email}</span>
                </Text>
                <Text>
                  Endereço:
                  <br />
                  {' - '}Estado:<span> {policyData?.TB_ADDRESS?.state}</span>
                  <br />
                  {' - '}Cidade:<span> {policyData?.TB_ADDRESS?.city}</span>
                </Text>

                <EndorsementCard style={{ marginTop: '24px' }}>
                  <EndorsementHeader>
                    <IoPersonOutline /> <h3>ALTERAÇÃO CADASTRAL</h3>
                  </EndorsementHeader>
                  <EndorsementGrid>
                    {(() => {
                      const updateData = endorsements?.user?.update_data
                        ? typeof endorsements.user.update_data === 'string'
                          ? JSON.parse(endorsements.user.update_data)
                          : endorsements.user.update_data
                        : null;

                      const showEmail = !updateData || updateData.old_data?.email !== updateData.new_data?.email;
                      const showPhone = !updateData || updateData.old_data?.phone !== updateData.new_data?.phone;

                      return (
                        <>
                          {showEmail && (
                            <EndorsementInfo>
                              <label>E-mail: De → Para</label>
                              <span className="value-row">
                                <span className="old">{updateData?.old_data?.email || '--'}</span>
                                <IoArrowForward size={14} color={middleGray} />
                                <span className="new">{updateData?.new_data?.email || '--'}</span>
                              </span>
                            </EndorsementInfo>
                          )}

                          {showPhone && (
                            <EndorsementInfo>
                              <label>Telefone: De → Para</label>
                              <span className="value-row">
                                <span className="old">
                                  {updateData?.old_data?.phone ? formatPhone(updateData.old_data.phone) : '--'}
                                </span>
                                <IoArrowForward size={14} color={middleGray} />
                                <span className="new">
                                  {updateData?.new_data?.phone ? formatPhone(updateData.new_data.phone) : '--'}
                                </span>
                              </span>
                            </EndorsementInfo>
                          )}

                          <EndorsementInfo>
                            <label>Responsável</label>
                            <span>{endorsements?.user?.TB_USERS_TB_CLIENT_HISTORY_id_authorToTB_USERS?.name || '--'}</span>
                          </EndorsementInfo>

                          <EndorsementInfo>
                            <label>Data</label>
                            <span>
                              {endorsements?.user?.created_at
                                ? moment(endorsements.user.created_at).format('DD/MM/YYYY HH:mm')
                                : '--'}
                            </span>
                          </EndorsementInfo>
                        </>
                      );
                    })()}
                  </EndorsementGrid>
                </EndorsementCard>
                <EndorsementDivider>
                  <span>Ações Disponíveis</span>
                </EndorsementDivider>

                {policyData?.status === 'active' && (
                  <Button className="buttonEndorsement" onClick={handleOpenEditUser} style={{ width: '100%', marginTop: '10px' }}>
                    {' '}
                    Editar usuário{' '}
                  </Button>
                )}

                <Dialog open={openUser} onClose={() => setOpenUser(false)} width="50%" title="Editar usuário">
                  <Input
                    widht="30%"
                    label="Nome social"
                    value={userData?.social_name}
                    onChange={(e) => setUserData({ ...userData, social_name: e.target.value.toUpperCase() })}
                    height="30px"
                  />
                  <Input
                    label="E-mail"
                    value={userData?.email}
                    onChange={(e) =>
                      setUserData({
                        ...userData,
                        email: e.target.value,
                      })
                    }
                  />
                  <Input
                    label="Telefone"
                    value={userData?.phone}
                    onChange={(e) =>
                      setUserData({
                        ...userData,
                        phone: e.target.value,
                      })
                    }
                  />

                  <ModalButton>
                    <Button
                      height="35px"
                      onClick={handleUpdateProposal}
                      disabled={!userData?.name || !userData?.cpf || !userData?.email || !userData?.phone || !userData?.birthdate}
                    >
                      Editar
                    </Button>
                  </ModalButton>
                </Dialog>
              </ItemPolicy>

              {/* ESTIPULANTE */}
              {policyData?.TB_PARTNER_STIPULATING && (
                <ItemPolicy>
                  <Subtitle>Informações do estipulante</Subtitle>
                  <Text>
                    Nome do estipulante: <span>{policyData?.TB_PARTNER_STIPULATING?.name}</span>
                  </Text>
                  <Text>
                    CNPJ: <span>{formatCNPJ(policyData?.TB_PARTNER_STIPULATING?.document)}</span>
                  </Text>
                  <Text>
                    Endereço: <span>{policyData?.TB_PARTNER_STIPULATING?.address}</span>
                  </Text>
                  <Text>
                    CEP: <span>{policyData?.TB_PARTNER_STIPULATING?.zipcode}</span>
                  </Text>
                </ItemPolicy>
              )}

              {/* CONDUTOR PRINCIPAL */}
              <ItemPolicy>
                <Subtitle>Informações do condutor principal</Subtitle>
                <Text>
                  Nome do segurado: <span>{policyData?.proposal?.maindriver_name || policyData?.user?.name}</span>
                </Text>
                <Text>
                  CPF: <span>{formatCPF(policyData?.proposal?.maindriver_document || policyData?.user?.cpf)}</span>
                </Text>
                {isCpf && (
                  <Text>
                    Data de nascimento:{' '}
                    <span>
                      {moment.utc(policyData?.proposal?.maindriver_birthdate || policyData?.user?.birthdate).format('DD/MM/YYYY')}
                    </span>
                  </Text>
                )}
              </ItemPolicy>

              {/* VEICULO */}
              <ItemPolicy>
                <Subtitle>Informações do veículo</Subtitle>
                <Text>
                  Marca e modelo: <span>{`${policyData?.vehicle?.brand}/${policyData?.vehicle?.model}`}</span>
                </Text>
                <Text>
                  Placa:{' '}
                  <span>{policyData?.vehicle?.plate === null ? 'Sem placa' : formatPlate(policyData?.vehicle?.plate)}</span>
                </Text>
                <Text>
                  Ano e modelo: <span>{`${policyData?.vehicle?.manufacture_year} / ${policyData?.vehicle?.year_model}`}</span>
                </Text>
                <Text>
                  Chassi: <span>{formatPlate(policyData?.vehicle?.chassi)}</span>
                </Text>
                <Text>
                  Uso do veículo: <span>{policyData?.vehicle?.vehicle_use?.name}</span>
                </Text>
                <Text>
                  Cor do veículo: <span>{policyData?.vehicle?.TB_CONSTANT_VEHICLE_COLOR?.name}</span>
                </Text>
                <Text>
                  Veículo de leilão: <span>{policyData?.vehicle?.auction ? 'SIM' : 'NÃO'}</span>
                </Text>
                <Text>
                  Chassis Remarcado/Veiculo Recuperado de Sinistro: <span>{policyData?.vehicle?.remarked ? 'Sim' : 'Não'}</span>
                </Text>
                <Text>
                  GNV: <span>{policyData?.vehicle?.gnv ? 'SIM' : 'NÃO'}</span>
                </Text>
                <Text>
                  Condutor entre 18 e 25 anos: <span>{policyInfo?.userBetween18and25Years ? 'SIM' : 'NÃO'}</span>
                </Text>
                <Text>
                  Valor FIPE: <span>{formatCurrency(policyData?.vehicle?.value || 0)}</span>
                </Text>
                <Text>
                  LMI {policyInfo?.adjustmentFactor}:{' '}
                  <span>{formatCurrency(policyData?.vehicle?.value * (policyInfo?.adjustmentFactorValue / 100) || 0)}</span>
                </Text>
              </ItemPolicy>

              {/* COBERTURAS */}
              <ItemPolicy>
                {hasCoverages && <Subtitle>Coberturas</Subtitle>}
                {policyData?.products?.length &&
                  policyData?.products
                    .filter((coverage) => coverage.isService === false)
                    .map((coverage) => <Text>• {coverage.name} </Text>)}
                {policyData?.coverages?.length &&
                  policyData?.coverages
                    .filter((product) => product.isService === false)
                    .map((product) => <Text>• {product.name} </Text>)}
                {policyData?.arrayUnique?.length &&
                  policyData?.arrayUnique
                    .filter((array) => array.isService === false)
                    .map((array) => <Text>• {array.name} </Text>)}
                {hasServices && <Subtitle style={{ paddingTop: '10px' }}>Serviços</Subtitle>}
                {policyData?.products?.length &&
                  policyData?.products
                    .filter((coverage) => coverage.isService === true)
                    .map((coverage) => <Text>• {coverage.name} </Text>)}
                {policyData?.coverages?.length &&
                  policyData?.coverages
                    .filter((product) => product.isService === true)
                    .map((product) => <Text>• {product.name} </Text>)}
                {policyData?.arrayUnique?.length &&
                  policyData?.arrayUnique
                    .filter((array) => array.isService === true)
                    .map((array) => <Text>• {array.name} </Text>)}
              </ItemPolicy>

              {/* VISTORIA */}
              <ItemPolicy>
                <Subtitle>Vistoria</Subtitle>
                <Text>
                  Código: <span>{policyData?.inspection?.inspection_code || 'N/A'}</span>
                </Text>
                <Text>
                  Status: <span>{translateInspectionStatus[policyData?.inspection?.status] || 'N/A'}</span>
                </Text>
                <Text>
                  Solicitada em:{' '}
                  <span>
                    {policyData?.inspection?.created_at ? moment(policyData?.inspection?.created_at).format('DD/MM/YYYY') : 'N/A'}
                  </span>
                </Text>
                <Text>
                  Finalizada em:{' '}
                  <span>
                    {policyData?.inspection?.result_date
                      ? moment(policyData?.inspection?.result_date).format('DD/MM/YYYY')
                      : 'N/A'}
                  </span>
                </Text>
                {policyData?.inspection?.result_date && (
                  <Button
                    height="25px"
                    width="200px"
                    loading={loadingGetReport}
                    onClick={() => handleGetReport(policyData?.inspection?.inspection_code)}
                  >
                    &nbsp; Visualizar documento &nbsp; <IoDocumentTextOutline />
                  </Button>
                )}
              </ItemPolicy>

              {/* ENDEREÇO */}
              <ItemPolicy>
                <Subtitle>Endereço do segurado</Subtitle>

                <Text>{/* CEP: <span>{formatZipCode(policyData?.address?.zip_code)}</span> */}</Text>
                <Text>
                  Endereço: <span>{policyData?.TB_ADDRESS?.street}</span>
                </Text>
                <Text>
                  Número:{' '}
                  <span>
                    {policyData?.TB_ADDRESS?.number} {policyData?.address?.complement}
                  </span>
                </Text>
                <Text>
                  Bairro: <span>{policyData?.TB_ADDRESS?.district}</span>
                </Text>
                <Text>
                  Cidade/UF:{' '}
                  <span>
                    {policyData?.TB_ADDRESS?.city}/{policyData?.TB_ADDRESS?.state}
                  </span>
                </Text>
                <Text>
                  Complemento: <span>{policyData?.TB_ADDRESS?.complement}</span>
                </Text>
              </ItemPolicy>
            </PolicyInformationArea>
          </ContentArea>
        )}
      </Container>
    </>
  );
}

export default PolicyDetails;
